var windowScrollTopBeforeShowPopUp = 0;


$(function() {

    if (popUpDetected()) popUpSetPosition();


    $(window).resize(function(event) {
        if (popUpDetected()) popUpSetPosition();
    });


    $('.show-pop-up').on('click', function(event) {
        var popUp = $(this).data('pop-up');

        if (popUp == 'payment-regular-lesson') {
            var id = $(this).data('group-id');

            if ($('.body-cover-pop-up-wrapper.payment-regular-lesson').length > 0) {
                $('.body-cover-pop-up-wrapper.payment-regular-lesson').empty().remove();
            }

            ajaxGetRegularLessonPaymentForm(id);
        }
        if (popUp == 'edit-learner') {
            var container = $(this).parents('.learner-container'),
                id = container.data('learner-id'),
                form = $('form.edit-learner');

            form.find('input[name="learner_id"]').val(id);
            form.find('input[name="last_name"]').val(container.find('.last-name').html());
            form.find('input[name="first_name"]').val(container.find('.first-name').html());

            showPopUp(popUp);
        }
        else {
            showPopUp(popUp);
        }
    });


    $('body').on('click', '.body-cover .back, .close-pop-up', function(event) {
        if (!$(this).hasClass('always-visible')) {
            hidePopUps();
        }
    });

});


// Проверка на существование видимого поп-апа
function popUpDetected() {
    return ($('.body-cover').hasClass('visible') && $('.body-cover-pop-up-wrapper.visible').length > 0) ? true : false;
}


// Показывает поп-ап
function showPopUp(popUpName) {
    closeMobileNav();

    if ($('.body-cover-pop-up-wrapper.visible').length > 0) $('.body-cover-pop-up-wrapper.visible').removeClass('visible');
    else windowScrollTopBeforeShowPopUp = windowScrollTop;

    $('.body-cover-pop-up-wrapper form').find('input, textarea, label').not('[type="hidden"]').removeClass('has-error');
    $('.body-cover-pop-up-wrapper.' + popUpName).addClass('visible');

    popUpAddBackImage();
    showBodyCover();
    popUpSetPosition();
}


// Скрывает все поп-апы
function hidePopUps() {
    hideBodyCover();
    $('.body-cover-pop-up-wrapper').removeClass('visible');
    $('.body-cover-pop-up-wrapper form').find('input, textarea').not('[type="hidden"]').removeClass('has-error');
}


// Показывает туман войны
function showBodyCover() {
    $('.body-cover').fadeIn(animateSpeed, function() {
        $(window).scrollTop(0);
        $('body').wrapInner( '<div class="unvisible-body"></div>');
        $('.body-cover, .notification-wrapper').appendTo('body');
        $('.unvisible-body').css('display', 'none');
        $(this).addClass('visible');

        $('.body-cover-pop-up-wrapper.visible form input').not('[type="hidden"]').eq(0).focus();
    });
}


// Скрывает туман войны
function hideBodyCover() {
    var cover = $('.body-cover');

    $('.unvisible-body >').appendTo('body');
    $('.unvisible-body').remove();
    $(window).scrollTop(windowScrollTopBeforeShowPopUp);
    cover.addClass('fixed');

    cover.fadeOut(0, function() {
        $(this).removeClass('visible fixed');
        $(this).find('.body-cover-pop-up-wrapper').removeClass('visible');
        $(this).find('.back').removeClass('back-image-1 back-image-2');
    });

}


// Позиционирует поп-ап
function popUpSetPosition() {
    var cover = $('.body-cover'),
        popUpWrapper = $('.body-cover-pop-up-wrapper.visible'),
        popUpWrapperHeight = popUpWrapper.outerHeight(),
        windowHeight = $(window).outerHeight();

    if (windowHeight > popUpWrapperHeight) popUpWrapper.css('top', parseInt((windowHeight - popUpWrapperHeight) * 2 / 5));
    else popUpWrapper.removeAttr('style');
}


// Добавляет фоновое изображение у поп-апа
function popUpAddBackImage() {
    var visiblePopUp = $('.body-cover-pop-up-wrapper.visible');

    if (visiblePopUp.hasClass('signin') || visiblePopUp.hasClass('signup') || visiblePopUp.hasClass('password-recovery') || visiblePopUp.hasClass('change-phone') || visiblePopUp.hasClass('change-password') || visiblePopUp.hasClass('add-learner') || visiblePopUp.hasClass('edit-learner')) $('.body-cover .back').removeClass('back-image-2').addClass('back-image-1');
    else if (visiblePopUp.hasClass('set-new-password') || visiblePopUp.hasClass('notification-payment-success') || visiblePopUp.hasClass('notification-payment-error') || visiblePopUp.hasClass('notification-payment-free-success') || visiblePopUp.hasClass('pre-entry-event') || visiblePopUp.hasClass('payment-event') || visiblePopUp.hasClass('payment-regular-lesson')) $('.body-cover .back').removeClass('back-image-1').addClass('back-image-2');
}